module.exports = __webpack_public_path__ + "static/media/inktober1 closeup3.e4d81b7a.jpg";